import './Cards.scss';
import state from '../state';
function Cards() {
    let Items = state.Cards.map((card, idx) =>
    {  
        return ( 
            <div  key={idx} className="card">
                <div class="wrapper">
                    <div class={card.class}>
                            <img class="card-pic" loading="lazy" alt={card.subtitle} src={card.src}></img>
                        <div class="card-desc">
                            <p class="card-desc_title">{card.title}</p>
                            <p class="card-desc_subtitle">{card.subtitle}</p>
                            <p class="card-desc_text">{card.text_1}</p>
                            <p class="card-desc_text">{card.text_2}</p>
                            <a class="btn-buy" href={card.href}>
                                Купить
                                <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.11286 7.6864C2.20755 6.65717 3.07087 5.86963 4.10445 5.86963H13.8956C14.9291 5.86963 15.7925 6.65717 15.8871 7.6864L16.7991 17.5994C16.907 18.7714 15.9845 19.7827 14.8076 19.7827H3.19245C2.01552 19.7827 1.09304 18.7714 1.20086 17.5994L2.11286 7.6864Z" stroke="#E5621F"/>
                                <path d="M12.825 5.86956C12.825 5.86956 11.112 5.86956 8.99894 5.86956C6.88585 5.86956 5.17285 5.86956 5.17285 5.86956C5.17285 3.18018 6.88585 1 8.99894 1C11.112 1 12.825 3.18018 12.825 5.86956Z" stroke="#E5621F"/>
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        )
    });
    return (
        <div className="card-list">
            {Items}
        </div>
    )
}
export default Cards;